// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import BookingDetails from 'components/new-booking/BookingDetails/BookingDetails';
import { getBooking } from 'services/booking';
import Booking from 'models/Booking';
import BOOKING_STAGE from 'constants/bookingStage';
import VetService from 'services/vet';
// Styles
import './styles.scss';

class Bookings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            booking: null,
            bookingId: props.match.params.id,
            stage: '',
            vetDetails: null,
        };
        this.getBookingDetails();
        this.getVetDetails();
    }

    getBookingDetails() {
        getBooking(this.state.bookingId)
            .then((response) => {
                const booking = Booking({
                    ...response.data, 
                    ...(this.shouldIncludeCollectionDetails(response) ? {collectionDetails: {}} : {})
                });
                const stage = BOOKING_STAGE.find((item) => item.sugarAPIStages.includes(booking.orderStage));
                this.setState({ booking, stage: stage ? stage.name : '' });
                localStorage.setItem('service-type-name',booking.serviceType.name.toLowerCase())
            }).catch((err) => {
                console.error('err :>> ', err);
            });
    }

    /**
     * Retrieves the vet details
     */
     getVetDetails = () => {
        VetService.getVetDetails()
            .then((response) => {
                this.setState({ vetDetails: response.data })
            }).catch((err) => {
                console.error(err);
            });
    }

    shouldIncludeCollectionDetails(response) {
        if(response?.data?.cstm?.service_type?.name && response?.data?.opportunity_type) {
            const serviceTypeName = response.data.cstm.service_type.name?.toLocaleLowerCase()
            const bookingType = response?.data?.opportunity_type

            if( 
                bookingType === 'vet_unity' && 
                serviceTypeName &&
                (
                    serviceTypeName === 'communal cremation - vet' ||
                    serviceTypeName?.includes('private cremation')
                )
            ) {
                return true
            }
        }

        return false
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content body-new-booking">
                    <PageTitle title="Booking details" />
                    {
                        this.state.booking
                            ? (
                                <ContentCard>
                                    <div className="booking-details-container">
                                        <BookingDetails booking={this.state.booking} vetDetails={this.state.vetDetails} />
                                    </div>
                                </ContentCard>
                            ) : null
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(Bookings);
